import { getErrorMessage } from '@/utils/getErrorMessage';
import { handleQuestionResolutionError } from './handleQuestionResolutionError';

export const getQuestionErrorMessage = (error: unknown) =>
  handleQuestionResolutionError(error) ?? getErrorMessage(error);
